import { LucideIcon, ShieldCheckIcon, XIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/button';

interface AuthPagePanelWrapperProps {
  title: string;
  icon?: LucideIcon;
  onClose: () => void;
  canClose?: boolean;
  children: React.ReactNode;
}

const AuthPagePanelWrapper = ({
  title,
  icon: Icon = ShieldCheckIcon,
  onClose,
  canClose = true,
  children,
}: AuthPagePanelWrapperProps) => {
  const { t } = useTranslation();

  return (
    <div className="flex h-full w-[360px] flex-col border-l border-border bg-background">
      <div className="flex h-12 shrink-0 items-center gap-2.5 px-2.5">
        <Icon size={28} className="text-muted-foreground" />
        <span className="text-sm font-semibold text-foreground">{title}</span>
        {canClose && (
          <Button
            variant="ghost-neutral"
            size="icon-sm"
            aria-label={t('common.collapse')}
            onClick={onClose}
            className="ml-auto"
          >
            <XIcon size={16} />
          </Button>
        )}
      </div>
      <div className="flex-1 overflow-x-hidden overflow-y-auto p-4">{children}</div>
    </div>
  );
};

export default AuthPagePanelWrapper;
